import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';

function norm(x){x=x||{};return Object.freeze({
 symbol:x.symbol||null,
 scope:['OWNED','WATCHLIST','RESEARCH'].includes(x.scope)?x.scope:'RESEARCH',
 priority:['CRITICAL','HIGH','MEDIUM','REVIEW','LOW','NONE'].includes(x.priority)?x.priority:'NONE',
 alertState:['EMIT','SUPPRESSED'].includes(x.alertState)?x.alertState:'SUPPRESSED',
 readiness:['READY_FOR_DECISION','REVIEW','BLOCKED'].includes(x.readiness)?x.readiness:'REVIEW',
 thesisDrift:x.thesisDrift||'STABLE',
 nextTask:x.nextTask||null,
 headline:x.headline||null
});}
function include(x){
 const n=norm(x);
 if(n.priority==='CRITICAL'&&n.scope==='OWNED') return true;
 if(n.alertState==='SUPPRESSED'&&n.thesisDrift==='STABLE') return false;
 return ['CRITICAL','HIGH','MEDIUM','REVIEW'].includes(n.priority);
}
function bucket(x){
 const n=norm(x);
 if(n.scope==='OWNED'&&n.readiness==='BLOCKED') return 'OWNED_BLOCKED';
 if(n.scope==='OWNED'&&n.priority==='CRITICAL') return 'OWNED_CRITICAL';
 if(n.scope==='OWNED') return 'OWNED_REVIEW';
 if(n.scope==='WATCHLIST') return 'WATCHLIST';
 return 'RESEARCH';
}
function digest(items,max){
 const rows=(Array.isArray(items)?items:[]).map(norm).filter(include);
 const order={OWNED_BLOCKED:5,OWNED_CRITICAL:4,OWNED_REVIEW:3,WATCHLIST:2,RESEARCH:1};
 const p={CRITICAL:6,HIGH:5,MEDIUM:4,REVIEW:3,LOW:2,NONE:1};
 rows.sort((a,b)=>order[bucket(b)]-order[bucket(a)]||p[b.priority]-p[a.priority]);
 const n=Number.isFinite(max)?Math.max(1,Math.floor(max)):6;
 return Object.freeze({
   top:Object.freeze(rows.slice(0,n).map(x=>Object.freeze({
     symbol:x.symbol,bucket:bucket(x),headline:x.headline||`${x.symbol||'Company'} needs ${x.readiness.toLowerCase().replaceAll('_',' ')}.`,
     nextTask:x.nextTask||'Review current evidence.',
     thesisDrift:x.thesisDrift
   }))),
   hiddenCount:Math.max(0,rows.length-n),
   totalAttention:rows.length,
   tradeSignal:false
 });
}
function selfTest(){
 const t=[],ok=(a,b)=>t.push({name:a,pass:!!b});
 const blocked={symbol:'AAA',scope:'OWNED',priority:'HIGH',alertState:'EMIT',readiness:'BLOCKED',thesisDrift:'MATERIAL_DRIFT'};
 const watch={symbol:'BBB',scope:'WATCHLIST',priority:'HIGH',alertState:'EMIT',readiness:'REVIEW',thesisDrift:'STABLE'};
 const noise={symbol:'CCC',scope:'OWNED',priority:'REVIEW',alertState:'SUPPRESSED',readiness:'REVIEW',thesisDrift:'STABLE'};
 ok('blocked owned item is included',include(blocked)===true);
 ok('suppressed stable noise is excluded',include(noise)===false);
 ok('blocked owned bucket is explicit',bucket(blocked)==='OWNED_BLOCKED');
 ok('watchlist remains distinct',bucket(watch)==='WATCHLIST');
 const d=digest([watch,noise,blocked],5);
 ok('digest removes suppressed noise',d.totalAttention===2);
 ok('blocked owned ranks first',d.top[0].symbol==='AAA');
 ok('digest remains non-trading',d.tradeSignal===false);
 ok('digest reports no hidden items when under cap',d.hiddenCount===0);
 ok('digest supplies next task fallback',digest([{...watch,nextTask:null}],5).top[0].nextTask.length>0);
 ok('digest supplies headline fallback',digest([{...watch,headline:null}],5).top[0].headline.length>0);
 return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,norm,include,bucket,digest,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestDailyAttentionOrchestrator=Object.freeze(API);
})(engineContext);
